import { render, staticRenderFns } from "./NoCaption.vue?vue&type=template&id=5fb31a54"
import script from "./NoCaption.vue?vue&type=script&lang=js"
export * from "./NoCaption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports